const MAC_PLATFORM_PATTERN = /Mac|iPhone|iPad|iPod/i;
export function isMacPlatform() {
    var _a, _b;
    if (typeof navigator === 'undefined') {
        return false;
    }
    const platform = (_a = navigator.platform) !== null && _a !== void 0 ? _a : '';
    const userAgent = (_b = navigator.userAgent) !== null && _b !== void 0 ? _b : '';
    return MAC_PLATFORM_PATTERN.test(platform) || MAC_PLATFORM_PATTERN.test(userAgent);
}
